import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';

export const useShipmentTemplateDrawerStyles = createStyles(({ token }) => ({
  templateOperationWarningText: {
    fontStyle: 'italic',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: token.fontSizeLG,
  },
  templateOperationWarningName: {
    fontSize: token.fontSizeLG,
    lineHeight: '19px',
    fontWeight: 'bold',
    color: ThemeColors.COLOR_ORANGE3,
  },
  deleteShipmentTemplateDialog: {
    '&&': {
      '.ant-modal-body': {
        display: 'block',
        paddingLeft: ThemeSpaces.SPACE_NORM_20,
        paddingRight: ThemeSpaces.SPACE_NORM_20,
      },
      'h1.ant-typography': {
        marginBottom: 0,
      },
    },
  },
  deleteShipmentTemplateDivider: {
    marginTop: ThemeSpaces.SPACE_NORM0_5,
    marginRight: -ThemeSpaces.SPACE_NORM_20,
    marginBottom: token.marginSM,
    marginLeft: -ThemeSpaces.SPACE_NORM_20,
  },
}));
